import React from 'react';
import {assignProps} from '@sail/engine';
import {Action, Menu, MenuItem, Icon} from '@sail/ui';
import {more} from '@sail/icons/react/Icon';
import {getStore} from 'src/v2/state/store';
import {useDisconnectWallet} from 'src/v2/components/pay/useDisconnectWallet';
import {message, useIntl} from '@sail/intl';

const messages = {
  changeNetwork: message({
    id: 'crypto.payins.v2.pay_screen.change_network',
    description: 'Menu option to change the blockchain network',
    defaultMessage: 'Change network',
  }),

  changeWallet: message({
    id: 'crypto.payins.v2.pay_screen.change_wallet',
    description: 'Menu option to change the wallet',
    defaultMessage: 'Change wallet',
  }),

  disconnectWallet: message({
    id: 'crypto.payins.v2.pay_screen.disconnect_wallet',
    description: 'Menu option to disconnect the wallet',
    defaultMessage: 'Disconnect wallet',
  }),
};

export const WalletActionMenu = ({disabled = false}: {disabled?: boolean}) => {
  const intl = useIntl();
  const store = getStore();
  const disconnectWallet = useDisconnectWallet();

  const activeWallet = store.useSelector(
    (state) => state.walletConnection.activeWallet,
  );

  const connectedWallets = store.useSelector(
    (state) => state.walletConnection.connectedWallets,
  );

  const handleChangeNetwork = () => {
    store.setValue((state) => {
      state.screen = 'NETWORK_SWITCH';
    });
  };

  const handleChangeWallet = () => {
    store.setValue((state) => {
      state.screen =
        connectedWallets.length > 1 ? 'WALLET_SWITCH' : 'WALLET_SELECT_GRID';
    });
  };

  const handleDisconnectWallet = () => {
    if (!activeWallet) {
      return;
    }

    disconnectWallet(activeWallet);
  };

  return (
    <Menu
      trigger={
        <Action
          disabled={disabled}
          css={{
            stack: 'y',
            alignX: 'center',
            alignY: 'center',
            width: 'xlarge',
            height: 'xlarge',
            opacity: disabled ? 0.5 : undefined,
            ':hover': {
              cursor: disabled ? 'default' : 'pointer',
            },
          }}
        >
          <Icon icon={more} size="xsmall" />
        </Action>
      }
      subviews={{
        popover: {uses: [assignProps({placement: 'bottom left'})]},
      }}
    >
      {activeWallet?.network !== 'solana' ? (
        <MenuItem onAction={handleChangeNetwork}>
          {intl.formatMessage(messages.changeNetwork)}
        </MenuItem>
      ) : null}
      <MenuItem onAction={handleChangeWallet}>
        {intl.formatMessage(messages.changeWallet)}
      </MenuItem>
      <MenuItem onAction={handleDisconnectWallet} type="destructive">
        {intl.formatMessage(messages.disconnectWallet)}
      </MenuItem>
    </Menu>
  );
};
